import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Flight/Flight.css";
import { GiCommercialAirplane, GiClick } from "react-icons/gi";
import {
  FiChevronRight,
  FiGlobe,
  FiPhone,
  FiClock,
  FiCheckCircle,
  FiDollarSign,
  FiShield,
  FiHeadphones,
} from "react-icons/fi";
import { FaPoundSign } from "react-icons/fa";
import { BsAirplane, BsCalendarCheck } from "react-icons/bs";
import Deal from "../Deal/Deal";
import WhyChoose from "../WhyChoose/WhyChoose";

const regionsData = [
  {
    id: "usa",
    region: "USA",
    image: "/san.webp",
  },
  {
    id: "canada",
    region: "Canada",
    image: "/canada.webp",
  },
  {
    id: "caribbean",
    region: "Caribbean",
    image: "/cari.webp",
  },

  {
    id: "asia",
    region: "Asia",
    image: "/india.webp",
  },

  {
    id: "latin-america",
    region: "Latin America",
    image: "/south.webp",
  },
  {
    id: "a&n",
    region: "Australia & New Zealand",
    image: "/australia.webp",
  },
  {
    id: "africa",
    region: "Africa",
    image: "/africa.webp",
  },
];

const Flight = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleCall = () => {
    window.location.href = `tel:02033557350  `;
  };

  const handlePromoClick = () => {
    window.location.href = "/contactus";
  };

  return (
    <>
      {/* Hero Section */}
      <div className="flight-hero-fls">
        <div className="flight-hero-content-fls">
          <h1 className="flight-hero-title-fls">
            Discover Your Next Adventure
          </h1>
          <p className="flight-hero-subtitle-fls">
            Explore premium flight deals to breathtaking destinations worldwide.
            Your dream journey begins here.
          </p>
        </div>
      </div>

      {/* Deal Component */}
      <div className="deal-render">
        <Deal showHeader={false} />
      </div>

      {/* Introduction Content */}
      <div className="flight-introduction-content">
        <div className="introduction-container">
          <h2 className="introduction-title">
            Find Affordable Flights to Popular Destinations
          </h2>
          <div className="introduction-text">
            <p>
              Travel isn't just a luxury – it's an essential part of life that
              rejuvenates the spirit, reignites our passion for living, and
              helps relieve stress. It provides a refreshing break from our
              fast-paced routines and connects us with diverse cultures and
              people around the world.
            </p>
            <p>
              That's why regular travel is so important – it brings welcome
              change to our daily lives and opens our eyes to new experiences.
              With countless destinations waiting to be explored, there's always
              somewhere new to discover and enjoy.
            </p>
            <p>
              Browse our selection of affordable flight destinations and embark
              on your next adventure with our exclusive flight deals that make
              world travel more accessible than ever.
            </p>
          </div>
        </div>
      </div>

      {/* Region Cards Grid */}
      <div className="regions-grid-container">
        <div className="regions-header">
          <h2 className="regions-title">Explore Regions</h2>
          <p className="regions-subtitle">
            Select a region to discover amazing destinations
          </p>
        </div>

        <div className="regions-grid">
          {regionsData.map((region) => (
            <Link
              key={region.id}
              to={`/flight/${region.id}`}
              className="region-card"
              onMouseEnter={() => setHoveredCard(`region-${region.id}`)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="region-card-image-container">
                <img
                  src={region.image}
                  alt={region.region}
                  className="region-card-image"
                />
                <div className="region-card-overlay">
                  <h3 className="region-card-title">{region.region}</h3>
                  <div className="region-card-arrow">
                    <FiChevronRight />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Information Section */}
      <div className="flight-information-section">
        <div className="information-container">
          {/* Cheap Flights Explained */}
          <div className="information-block">
            <div className="information-h-div">
              <div className="information-icon-wrapper">
                <FaPoundSign className="information-icon" />
              </div>
              <h3 className="information-subtitle">
                How Click4Flight keeps flights affordable
              </h3>
            </div>
            <div className="information-text">
              <p>
                Click4Flight connects travelers with cost-efficient flight
                options by sourcing the most competitive fares and exclusive
                airline offers available at the time of booking. Our platform is
                designed to help you fly more while spending less.
              </p>
              <p>
                We focus on delivering smart pricing without cutting corners—so
                you enjoy a comfortable, dependable journey backed by trusted
                airline partners and seamless service.
              </p>
            </div>
          </div>

          {/* Benefits */}
          <div className="information-block">
            <div className="information-h-div">
              <div className="information-icon-wrapper">
                <FiCheckCircle className="information-icon" />
              </div>
              <h3 className="information-subtitle">
                What makes Click4Flight the right choice?
              </h3>
            </div>
            <div className="benefits-list">
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Value-driven fares across popular routes</span>
              </div>
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Fair pricing with complete cost clarity</span>
              </div>
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Quick and intuitive booking experience</span>
              </div>
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Encrypted and trusted payment processing</span>
              </div>
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Multiple airlines and flexible fare options</span>
              </div>
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Guidance from experienced travel advisors</span>
              </div>
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Special offers on urgent and last-minute trips</span>
              </div>
              <div className="benefit-item">
                <FiCheckCircle className="benefit-icon" />
                <span>Customer assistance available at all hours</span>
              </div>
            </div>
            <p className="benefits-summary">
              Every feature at Click4Flight is built to simplify travel planning
              while maximizing convenience, confidence, and savings.
            </p>
          </div>

          {/* Role & Commitment */}
          <div className="information-block">
            <div className="information-h-div">
              <div className="information-icon-wrapper">
                <BsAirplane className="information-icon" />
              </div>
              <h3 className="information-subtitle">
                Our responsibility to every traveler
              </h3>
            </div>
            <div className="information-text">
              <p>
                The Click4Flight team continuously monitors airfare trends to
                identify meaningful savings opportunities, ensuring travelers
                receive offers that genuinely add value.
              </p>
              <p>
                From advance planning to spontaneous travel, we provide reliable
                flight choices designed to match diverse schedules, preferences,
                and budgets.
              </p>
            </div>
          </div>

          {/* Free Consultation */}
          <div className="information-block">
            <div className="information-h-div">
              <div className="information-icon-wrapper">
                <FiHeadphones className="information-icon" />
              </div>
              <h3 className="information-subtitle">
                Expert support at no additional cost
              </h3>
            </div>
            <div className="information-text">
              <p>
                Click4Flight offers complimentary travel assistance to help with
                booking decisions, fare comparisons, urgent travel needs, and
                general flight-related guidance.
              </p>
              <div className="consultation-highlight">
                <FiClock className="highlight-icon" />
                <div>
                  <h4>Always within reach</h4>
                  <p>Assistance available 24 hours a day, 7 days a week</p>
                </div>
              </div>
              <p>
                Our advisors are committed to delivering clear answers and
                tailored solutions, ensuring your booking experience remains
                smooth, informed, and stress-free.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar - Placed at the end as requested */}
      <aside className="flight-sidebar-fls">
        {/* Support Widget */}
        <div className="support-widget-fls" onClick={handleCall}>
          <div className="support-header-fls">
            <FiPhone className="support-icon-fls" />
            <h3>24/7 Premium Support</h3>
          </div>
          <div className="support-content-fls">
            <p className="support-text-fls">
              Our dedicated travel experts are available round the clock to
              ensure your journey is seamless and memorable.
            </p>
            <div className="call-section-fls">
              <span className="call-label-fls">
                Call our travel specialists
              </span>
              <div className="phone-number-fls">
                02033557350
                <GiClick className="click-icon-fls" />
              </div>
              <div className="support-hours-fls">
                <FiClock className="clock-icon-fls" />
                Available 24 hours, 7 days a week
              </div>
            </div>
          </div>
        </div>

        {/* Promo Section */}
        <div className="promo-section-fls" onClick={handlePromoClick}>
          <img
            src="/promo.avif"
            alt="Luxury Air Travel Experience"
            className="promo-image-fls"
          />
          <div className="promo-overlay-fls">
            <h4>Premium Travel Experience</h4>
            <p>Luxury meets affordability • Exclusive member deals available</p>
            <div className="promo-badge-fls">
              <span>Limited Time Offer</span>
            </div>
          </div>
        </div>
      </aside>
      <WhyChoose />
    </>
  );
};

export default Flight;
